import { useCallback } from 'react';

export type Appearance = 'light' | 'dark' | 'system';

const setCookie = (name: string, value: string, days = 365) => {
    if (typeof document === 'undefined') {
        return;
    }

    const maxAge = days * 24 * 60 * 60;
    document.cookie = `${name}=${value};path=/;max-age=${maxAge};SameSite=Lax`;
};

export function initializeTheme() {
    // Always apply light theme
    document.documentElement.classList.remove('dark');
    
    // Clear any stored preferences
    localStorage.removeItem('appearance');
    setCookie('appearance', 'light');
}

export function useAppearance() {
    // Always return light theme, no ability to change
    const appearance: Appearance = 'light';

    // updateAppearance does nothing but is kept for compatibility
    const updateAppearance = useCallback((mode: Appearance) => {
        // Do nothing - theme is always light
    }, []);

    return { appearance, updateAppearance } as const;
}
